module.exports = __webpack_public_path__ + "static/media/galerija_2019 (1).757c4dcd.jpg";